module.exports = __webpack_public_path__ + "assets/65b0132234ff3da0a9942f74392aa34d.png";